export default __webpack_public_path__ + "static/media/ship.04b8ab05.svg";